import { render, staticRenderFns } from "./DepositSubscriptionCard.vue?vue&type=template&id=15cf461d&scoped=true&"
import script from "./DepositSubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./DepositSubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./DepositSubscriptionCard.vue?vue&type=style&index=0&id=15cf461d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf461d",
  null
  
)

export default component.exports